import FormNav from "../FormNav";

export default function TestNav() {
  return <FormNav logoAlt="scs-education-logo" variant="solid" />;
}
